import type { FileUploadOptions } from "#types/FileUploadOptions.ts";
import { create } from "zustand";

interface FileUploadOptionsStore {
    fileUploadOptions?: FileUploadOptions;
    setFileUploadOptions: (options?: FileUploadOptions) => void;
}

export const useFileUploadOptionsStore = create<FileUploadOptionsStore>()(set => ({
    fileUploadOptions: undefined,
    setFileUploadOptions: fileUploadOptions => set({ fileUploadOptions })
}));
